<script setup>
import VClamp from "vue-clamp";
import {ref, watch} from "vue";
import needsStartupsService from "@/services/needs-startups.service";
import {getLogo} from "@/helpers/logo";
import StartupInfo from "@/views/needs/need/StartupInfo.vue";

const props = defineProps({
    startup: {
        type: Object
    },
    dummy: {
        type: Boolean,
        default: false
    },
    source: String,
});

const showDetails = ref(false);
const startupDetails = ref(null);

watch(() => props.startup, () => {
    showDetails.value = false;

    if (!props.dummy) {
        getStartupDetails();
    }
}, {immediate: true});

async function getStartupDetails() {
    const {data} = await needsStartupsService.getStartupDetails(props.startup.link_id);
    startupDetails.value = data;
}

defineExpose({
    showDetails
})
</script>

<template>
    <div class="matchmaking__container">
        <header class="matchmaking__content__header">
            <div class="image-block">
                <img :src="getLogo(startup.logo)" alt=""/>
            </div>
            <div>
                <h5 class="heading5 heading5--secondary">{{ startup.name }}</h5>
                <!-- <p class="modal-matchmaking__content__by modal-matchmaking__content__by--recommended">Recommended by AI</p> -->
                <p v-if="source === 'ecosystem'"
                   class="matchmaking__content__by matchmaking__content__by--sent">Sent by {{ startup.ecosystem_name }}
                </p>
            </div>

            <div class="matchmaking__content__header__side">
                <div v-if="source === 'ai'" class="vc-label">AI Recommended</div>

                <div v-if="showDetails" @click="showDetails = false"
                     class="modal-matchmaking__minimize"></div>
             </div>
        </header>

        <template v-if="!showDetails">
            <div class="matchmaking__content__inner">
                <p class="modal-matchmaking__content__text">
                    <VClamp autoresize :max-lines="5"> {{ startup.description }}
                        <template #after="{ clamped }">
                            <a v-if="clamped" class="link-normal" @click="showDetails = true"> more</a>
                        </template>
                    </VClamp>
                </p>
                <template v-if="startup.clients.length">
                    <h5 class="heading5 heading5--secondary">Clients:</h5>
                    <ul class="list">
                        <li v-for="client in startup.clients" :key="client">
                            {{ client }}
                        </li>
                    </ul>
                </template>

<!--                <div v-if="false" class="matchmaking__textarea">-->
<!--                    <p>Malcolm Reynolds, <b>NEA</b>:</p>-->
<!--                    <p><i>Gamma Core is an exciting startup that has been scaling up quickly and would-->
<!--                        be a good fit for your need. They spent the last year working with Lorem Corp-->
<!--                        successfully and are ready for their next challenge.</i></p>-->
<!--                </div>-->
            </div>
            <footer class="modal-matchmaking__content__footer">
                <a href="#" @click.prevent="showDetails = true">More Details</a>
            </footer>
        </template>

        <StartupInfo
            v-else-if="startupDetails"
            :startup="startupDetails"
        >
            <template #addSection>
                <div class="modal-matchmaking__stat">
                    <div v-if="startup.match_score" class="modal-matchmaking__stat__item modal-matchmaking__stat__item--match">
                        Match Score: {{ startup.match_score }}/10
                    </div>
                    <div class="modal-matchmaking__stat__item modal-matchmaking__stat__item--score">
                        IRL Score: {{ startup.irl_score }}/10
                    </div>
                </div>
            </template>
        </StartupInfo>
    </div>
</template>
<style scoped>
    .modal-matchmaking__content__inner {
        flex: 1;
    }
</style>
